import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class JsonTypeVehiclesService {
  constructor() {}
  serviceListVehicles = [
    {name: 'BICICLETA', url: 'assets/images/ic_bicycle.png'},
    {name: 'MOTOCICLETA', url: 'assets/images/ic_bike.png'},
    {name: 'CAMIÓN', url: 'assets/images/ic_camion.png'},
    {name: 'VOLQUETA', url: 'assets/images/ic_volqueta.png'},
    {name: 'MEZCLADORA', url: 'assets/images/ic_mezclador.png'},
    {name: 'AUTOMOVIL', url: 'assets/images/ic_vehicle.png'},
    {name: 'BUS', url: 'assets/images/ic_bus.png'},
    {name: 'CAMIONETA', url: 'assets/images/ic__camioneta.PNG'},
    {name: 'CAMPERO', url: 'assets/images/ic_campero.PNG'},
    {name: 'CARRO', url: 'assets/images/ic_car.png'},
    {name: 'TRACTOR', url: 'assets/images/ic_tractor.png'},
    {name: 'MAQUINARIA PESADA', url: 'assets/images/ic_excavator.PNG'}
  ];
  

}